import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {TargetGroup, TARGETGROUP_DUMMIES} from 'shared/models/target-groups/target-group';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {TargetGroupsListService} from './services/target-groups-list.service';

@Component({
  selector: 'target-groups-list',
  templateUrl: './target-groups-list.component.html',
  styleUrls: ['./target-groups-list.component.css'],
})

export class TargetGroupsListComponent implements OnInit {
  public allTargetGroups: Array<TargetGroup> = [];
  public filteredTargetGroups: Array<TargetGroup>;
  public fieldsToSearch: Array<Array<String>> = [];
  public searchTerm: String;
  public currentPage: Event;

  constructor(private targetGroupsListService: TargetGroupsListService,
              private router: Router) { }

  public ngOnInit(): void {
    this.getAllTargetGroups();
  }

  public getAllTargetGroups(): void {
    this.targetGroupsListService.getAllTargetGroups()
      .subscribe((allTargetGroups: Array<TargetGroup>) => {
        this.allTargetGroups = allTargetGroups.filter((group) => { return !TARGETGROUP_DUMMIES.includes(group.title)});
        this.filteredTargetGroups = allTargetGroups.filter((group) => { return !TARGETGROUP_DUMMIES.includes(group.title)});
        this.prepareFieldsToSearch();
      });
  }

  public filterTargetGroups(eventTargetGroups: Array<TargetGroup>): void {
    this.filteredTargetGroups = eventTargetGroups;
  }

  public goToCreate(): void {
    this.router.navigateByUrl('targetgroups/details');
  }

  public goToDetails(targetGroup: TargetGroup): void {
    this.router.navigate(['targetgroups', 'details', {targetGroupId: targetGroup._id}]);
  }

  private prepareFieldsToSearch(): void {
    this.allTargetGroups.forEach((targetGroup: TargetGroup) => {
      this.fieldsToSearch.push([
        targetGroup.title.toLowerCase(),
      ]);
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/target-groups-list/target-groups-list.component.ts